export const EASE = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 22 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.55, ease: EASE, delay: i * 0.06 } }),
};

export const stagger = { hidden: {}, show: { transition: { staggerChildren: 0.09, delayChildren: 0.05 } } };

export const lineReveal = {
  hidden: { y: "112%" },
  show: (i = 0) => ({ y: 0, transition: { duration: 0.7, ease: EASE, delay: 0.05 + i * 0.09 } }),
};

export const viewport = { once: true, margin: "-6% 0px" };
